module.exports = __webpack_public_path__ + "static/media/road-C.ec8263f9.svg";